import { z } from 'zod'

export const OpsVettingURLParams = z.object({
	id: z.coerce.number().int()
})
export type OpsVettingURLParams = z.infer<typeof OpsVettingURLParams>

export const VettingItemStatus = z.enum([
	'accepted',
	'declined',
	'back_to_draft'
])
export type VettingItemStatus = z.infer<typeof VettingItemStatus>
